module.exports = __webpack_public_path__ + "a27a3654fba544169150b02d3a699986.png";